export type CallWindowMode = 'minimized' | 'windowed' | 'fullscreen' | 'pip';

export interface CallWindowPresentation {
  mode: CallWindowMode;
  focusSurface: true;
  separateDocument: boolean;
  layer: 9000 | null;
}

/**
 * Shared presentation contract used by the call window and focused tests.
 * PiP has its own document/stacking context; every main-document mode uses
 * the same focus-surface marker and reserved call layer.
 */
export function resolveCallWindowPresentation({
  minimized,
  fullscreen,
  pipped,
}: {
  minimized: boolean;
  fullscreen: boolean;
  pipped: boolean;
}): CallWindowPresentation {
  const mode: CallWindowMode = pipped
    ? 'pip'
    : fullscreen
      ? 'fullscreen'
      : minimized
        ? 'minimized'
        : 'windowed';
  return {
    mode,
    focusSurface: true,
    separateDocument: mode === 'pip',
    layer: mode === 'pip' ? null : 9000,
  };
}